import type { ProseMirrorContent } from "@shared/models/card-stack"
import Patch from "@shared/models/patch-updater"

interface Payload {
  cardStackId: string
  planbookId: string
  courseId: string | null
  dateString: string | null
  proseMirror: ProseMirrorContent
}

export const LESSON_UNIFIED_INTERMEDIATE_UPDATE = {
  name: "LESSON_UNIFIED_INTERMEDIATE_UPDATE",

  patches(payload: Payload) {
    return [
      Patch.create("card-stack", payload.cardStackId).set(
        "attributes.proseMirror",
        payload.proseMirror
      ).patch,
    ]
  },

  undoPatches: null,

  narrative: null,
}
